import {
  getBidProductApi,
  getUpNextProductApi,
  getFinishedProductApi,
  getResultsProductApi,
  bidHistoryApi,
  getResultDetailProductApi,
  getFinishedDetailProductApi,
  bidHistoryAllApi,
  checkStatusEventNewYearAPI,
  getStatisticEventNewYearApi,
  getHistoryEventNoelApi,
  postPairingEventNewYearApi,
} from "@api/product";
import { getPotentialWinnerApi } from "@api/product";

export const productKey = "product";
export const productUpNextKey = "product-up-next";
export const productFinishedKey = "product-finished";
export const productFinishedDetailKey = "product-finished-detail";
export const productResultsKey = "product-results";
export const productResultDetailKey = "product-result-detail";
export const bidHistoryKey = "bid-history";
export const bidHistoryAllKey = "bid-history-all";
export const queryKeyPotentialWinner = "potential_winner";
// event
export const productCheckStatusEvent = "product-check-status-event";
export const productGetStatisticEvent = "product-get-statistic-event";
export const productHistoryEventNoel = "history-event-noel";
export const productPairingEventNewYear = "pairing-event-new-year";

export const getBidProduct = () => ({
  queryKey: [productKey],
  queryFn: getBidProductApi,
});

export const getUpNextProduct = () => ({
  queryKey: [productUpNextKey],
  queryFn: getUpNextProductApi,
});

export const getFinishedProduct = () => ({
  queryKey: [productFinishedKey],
  queryFn: getFinishedProductApi,
});

export const getFinishedDetailProduct = (cp_id) => ({
  queryKey: [productFinishedDetailKey, { cp_id }],
  queryFn: getFinishedDetailProductApi,
});

export const getResultsProduct = () => ({
  queryKey: [productResultsKey],
  queryFn: getResultsProductApi,
});

export const getResultDetailProduct = (cp_id) => ({
  queryKey: [productResultDetailKey, { cp_id }],
  queryFn: getResultDetailProductApi,
});

export const getHistoryBid = (
  cp_ids,
  page = 1,
  sort = "desc",
  pageSize = 10
) => ({
  queryKey: [bidHistoryKey, { cp_ids, page, sort, pageSize }],
  queryFn: bidHistoryApi,
});

export const getHistoryBidAll = (page = 1, sort = "desc", pageSize = 10) => ({
  queryKey: [bidHistoryAllKey, { page, sort, pageSize }],
  queryFn: bidHistoryAllApi,
});

export const getPotentialWinner = (cp_ids) => ({
  queryKey: [queryKeyPotentialWinner, cp_ids],
  queryFn: getPotentialWinnerApi,
});

// event
export const getCheckStatusEvent = () => ({
  // queryKey: [productCheckStatusEvent],
  // queryFn: checkStatusEventNewYearAPI,
});

export const getStatisticEvent = () => ({
  queryKey: [productGetStatisticEvent],
  queryFn: getStatisticEventNewYearApi,
});

export const getHistoryEventNoel = (page = 1, limit = 10) => ({
  queryKey: [productHistoryEventNoel, { page, limit}],
  queryFn: getHistoryEventNoelApi,
});

export const postPairingEventNewYear = () => ({
  queryKey: [productPairingEventNewYear],
  queryFn: postPairingEventNewYearApi,
}); 
